import React from "react";
import { graphql } from "gatsby";

import { LocaleContext } from "../components/layout";
import MainBlock from "../components/home/Main";
import Footer from "../components/Footer";
import PresentantionHome from "../components/home/Presentation_home";
import FocusHome from "../components/home/Focus_home";
import StaffHeader from "../components/home/Staff_home";
import OurAdventures from "../components/home/our-adventures";
import CTAHome from "../components/home/CTAhome";
import UneteBlock from "../components/home/unete-block";
import HomeHeroVideo from "../components/home/home-hero-video";
import Header from "../components/header";
import CustomHeader from "../components/shared/CustomHeader";
import EirProgramBlock from "../components/home/eir-pogram";
import PortfolioGrid from "../components/home/portfolio-grid";

// import bannermovil from "../img/cornavirus/banner-coronavirus-movil.png";
// import bannertablet from "../img/cornavirus/banner-coronavirus-tablet.png";
// import bannerdesktop from "../img/cornavirus/banner-coronavirus-desktop.png";

const Index = (props) => {
  const data = props.data;
  const staticText = data.allPrismicHome.edges[0].node.data;
  const lang = React.useContext(LocaleContext);
  // const i18n = lang.i18n[lang.locale];

  return (
    <div className="main">
      <HomeHeroVideo lang={lang} text={staticText}></HomeHeroVideo>
      {/* <MainBlock texs={staticText} lang={lang} /> */}
      {/* <Header theme="dark" lang={lang} /> */}
      {/* <HomeHeroVideo></HomeHeroVideo> */}
      <CustomHeader title="Zubi Labs" defer={false}></CustomHeader>
      <PresentantionHome texs={staticText} />
      <EirProgramBlock data={staticText}></EirProgramBlock>
      <FocusHome text={staticText} />
      {/* <UneteBlock info={staticText}></UneteBlock> */}
      {/* <CTAHome info={staticText} /> */}
      {/* <OurAdventures
        data={data.allPrismicProjects.edges}
        dataNumbers={staticText}
      /> */}
      <PortfolioGrid data={data.allPrismicProjects.edges}></PortfolioGrid>
      {/* <StaffHeader data={props.data.allPrismicEmployee.edges} /> */}
      <Footer loveText={staticText.footer_text} />
    </div>
  );
};

export default Index;

export const query = graphql`
  query ($locale: String!) {
    allPrismicHome(filter: { lang: { eq: $locale } }) {
      edges {
        node {
          id
          lang
          data {
            main_title {
              text
            }
            main_text {
              text
            }
            about_title {
              text
            }
            about_text {
              html
            }
            focus_1_title {
              text
            }
            focus_1_text {
              text
            }
            focus_2_title {
              text
            }
            focus_2_text {
              text
            }
            img_cabecera {
              url
            }
            eir_program_img {
              url
            }
            eir_program_tittle {
              text
            }
            eir_program_subtittle {
              text
            }
            eir_program_text {
              html
            }
            eir_program_btn_text {
              text
            }
            eir_program_btn_link {
              url
            }
            adventures_data {
              number {
                html
                text
              }
              title_text {
                html
                text
              }
            }
            estadisticas_de_impacto {
              title_number {
                html
                text
              }
              description {
                html
                text
              }
            }
            cta_group {
              icon {
                url
              }
              copy_cta {
                text
              }
              link_cta {
                text
              }
              button_text {
                text
              }
            }
            footer_text {
              text
            }
          }
        }
      }
    }
    allPrismicProjects(
      filter: { lang: { eq: $locale } }
      sort: { fields: [data___order_home], order: ASC }
    ) {
      edges {
        node {
          id
          uid
          lang
          data {
            order_home
            name {
              html
              text
            }
            info {
              html
              text
            }
            img {
              url
            }
            logo {
              url
            }
            estado
            link {
              url
            }
            logo_grid_color {
              url
            }
            logo_bn {
              url
            }
            descripcion {
              html
            }
            stast_1_num {
              text
            }
            stast_2_num {
              text
            }
            stats_1_text {
              text
            }
            stats_2_text {
              text
            }
            ods_group {
              ods_item {
                document {
                  ... on PrismicOds {
                    id
                    data {
                      img {
                        url
                      }
                      title {
                        html
                        raw
                        text
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    allPrismicEmployee(
      sort: { fields: uid }
      filter: { data: { portada: { eq: "true" } }, lang: { eq: $locale } }
    ) {
      edges {
        node {
          id
          uid
          lang
          data {
            name {
              html
              text
            }
            lastname {
              html
              text
            }
            position {
              html
              text
            }
            img {
              url
            }
            linkedin_profile {
              url
            }
          }
        }
      }
    }
  }
`;
